import React, { Component } from "react";
import { connect } from "react-redux";
import { editExternalApp } from "../redux/actions/appActions";
import { EditExternalAppDialog } from "../dialogs/EditExternalAppDialog";
import { mapKV } from "../utils/map";

export class EditExternalApp extends Component {
  state = {
    title: "",
    packageName: "",
    packageNameNotUnique: false,
    description: "",
    categories: [],
    saveAvaliable: true,
    organizationKey: "",
    globalAccess: false,
    sortPriority: 0
  };

  componentDidMount() {
    const {
      app: {
        title,
        packageName,
        description,
        categories,
        organizationRef,
        globalAccess,
        sortPriority = 0,
      }
    } = this.props;
    const organizationKey = organizationRef.id;
    this.setState({
      title,
      packageName,
      description,
      categories,
      organizationKey,
      globalAccess,
      sortPriority
    });
  }

  onTitleChange = title => this.setState({ title }, this.checkSaveAvaliable);

  onPackageNameChange = packageName =>
    this.setState({ packageName }, this.checkSaveAvaliable);

  onDescriptionChange = description => this.setState({ description });

  onIconFileChange = icon => this.setState({ icon }, this.checkSaveAvaliable);

  onOrganizationChange = organizationKey =>
    this.setState({ organizationKey }, this.checkSaveAvaliable);

  onGlobalAccessChange = globalAccess => this.setState({ globalAccess });

  onSortPriorityChange = input => {
    if(input.length === 0) input = 0;
    let sortPriority = parseInt(input);
    if(isNaN(sortPriority)) sortPriority = this.state.sortPriority;
    if(input==="-")sortPriority="-";
    this.setState({ sortPriority });
  }

  saveChanges = () => {
    const {
      title,
      packageName,
      description,
      categories,
      icon,
      organizationKey,
      globalAccess,
      sortPriority
    } = this.state;
    const { selectedKey, onClose, editExternalApp, app } = this.props;
   
    editExternalApp(
      selectedKey,
      title,
      packageName,
      description,
      categories,
      icon,
      app.iconUrl,
      organizationKey,
      globalAccess,
      isNaN(parseInt(sortPriority)) ? 0 : sortPriority
    );
    onClose();
  };

  closeDialog = () => {
    this.props.closeAddDialog();
  };

  checkSaveAvaliable = () => {
    const { title, packageName, organizationKey } = this.state;
    const { allApps, selectedKey } = this.props;
    let packageNameNotUnique = false;
    mapKV(allApps, (key, app) => {
      if (key === selectedKey) return;
      if (packageName === app.packageName && app.organizationRef.id === organizationKey) {
        packageNameNotUnique = true;
      }
    });
    this.setState({ packageNameNotUnique });
    let saveAvaliable = true;
    if (
      title === "" ||
      packageName === "" ||
      packageNameNotUnique ||
      organizationKey === ""
    )
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onCategoriesChange = categories => {
    this.setState({ categories });
  };

  render() {
    const { allCategories, onClose, app } = this.props;
    const {
      title,
      packageName,
      packageNameNotUnique,
      icon,
      categories,
      description,
      saveAvaliable,
      organizationKey,
      globalAccess,
      sortPriority
    } = this.state;
    return (
      <EditExternalAppDialog
        app={app}
        onClose={onClose}
        onSave={this.saveChanges}
        saveAvaliable={saveAvaliable}
        title={title}
        onTitleChange={this.onTitleChange}
        packageName={packageName}
        onPackageNameChange={this.onPackageNameChange}
        packageNameNotUnique={packageNameNotUnique}
        categories={categories}
        onCategoriesChange={this.onCategoriesChange}
        sortPriority={sortPriority}
        onSortPriorityChange={this.onSortPriorityChange}
        description={description}
        onDescriptionChange={this.onDescriptionChange}
        iconName={icon && icon.name}
        onIconFileChange={this.onIconFileChange}
        allCategories={allCategories}
        organizationKey={organizationKey}
        onOrganizationChange={this.onOrganizationChange}
        globalAccess={globalAccess}
        onGlobalAccessChange={this.onGlobalAccessChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  allApps: state.data.apps,
  currentUser: state.user.user
});

const mapDispatchToProps = {
  editExternalApp
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditExternalApp);
